import { createRoute } from "@tanstack/react-router";
import { ConsultantTerritoriesPage } from "@/components/consultants/consultant-territories-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/consultants/territories",
  component: ConsultantTerritoriesPage,
});
